import {
  createElementBlock as _createElementBlock,
  createElementVNode as _createElementVNode,
  openBlock as _openBlock
} from 'vue'

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 24 24',
        width: '24',
        height: '24',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '1.5',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
      },
      [
        _createElementVNode('circle', {
          cx: '12',
          cy: '12',
          r: '9',
          fill: 'none'
        }),
        _createElementVNode('path', {
          d: 'M12 6v6l4 2',
          fill: 'none'
        })
      ]
    )
  )
}
